import React from 'react'
import moment from 'moment'

export type DateTextProps = {
  dateString?: string;
  type: 'jp-date'
};

export default function DateText ({
  dateString
}: DateTextProps) {
  return (
    <span>
      { moment(dateString).format('YYYY年 MM月 DD日') }
    </span>
  )
}
